"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessagesRestService = void 0;
const BaseRestService_1 = __importDefault(require("../BaseRestService"));
const utils_1 = require("@sqvr/utils");
class MessagesRestService extends BaseRestService_1.default {
  constructor() {
    super(...arguments);
    this.basePath = '/user';
  }
  getRecentChats(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        count,
        page
      } = request;
      return this.send(utils_1.GET, `count=${count}&page=${page}`, `/contacts/recent`, Object.assign({}, options), requestOptions);
    });
  }
  getMessages(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        count,
        page,
        userId
      } = request;
      return this.send(utils_1.GET, count && page ? `count=${count}&page=${page}` : '', `/contacts/${userId}/messages`, Object.assign({}, options), requestOptions);
    });
  }
  getContacts(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        count,
        page,
        search
      } = request;
      return this.send(utils_1.GET, `count=${count}&page=${page}&search=${search}`, '/contacts', Object.assign({}, options), requestOptions);
    });
  }
  getUserById(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        id
      } = request;
      return this.send(utils_1.GET, `user_id=${id}`, '/contacts', Object.assign({}, options), requestOptions);
    });
  }
  getSearchMessage(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        count,
        page,
        search
      } = request;
      return this.send(utils_1.GET, `count=${count}&page=${page}&search=${search}`, '/messages/search', Object.assign({}, options), requestOptions);
    });
  }
  deleteMessage(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        id,
        userId
      } = request;
      return this.send(utils_1.DELETE, null, `/contacts/${userId}/messages`, Object.assign(Object.assign({}, options), {
        body: JSON.stringify({
          id
        })
      }), requestOptions);
    });
  }
  sendMessage(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        userId,
        text,
        replied_message_id,
        documents
      } = request;
      return this.send(utils_1.POST, null, `/contacts/${userId}/messages`, Object.assign(Object.assign({}, options), {
        body: JSON.stringify({
          text,
          replied_message_id,
          documents
        })
      }), requestOptions);
    });
  }
  editMessage(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
          userId
        } = request,
        body = __rest(request, ["userId"]);
      return this.send(utils_1.PATCH, null, `/contacts/${userId}/messages`, Object.assign(Object.assign({}, options), {
        body: JSON.stringify(body)
      }), requestOptions);
    });
  }
}
exports.MessagesRestService = MessagesRestService;
const messagesRestService = new MessagesRestService();
exports.default = messagesRestService;